<template>
  <div class="promotion-container">
    <div class="page-header">
      <div class="breadcrumb">ວິຊາການ / <span>ເລືອນຊັ້ນນັກຮຽນ</span></div>
      <div class="header-content">
        <h1>ເລືອນຊັ້ນນັກຮຽນ</h1>
        <p>ຄັດເລືອກນັກຮຽນທີ່ເສັງຜ່ານເພື່ອເລືອນຂຶ້ນຊັ້ນຮຽນໃໝ່ ຫຼື ຫ້ອງຮຽນໃໝ່</p>
      </div>
    </div>

    <!-- ສ່ວນຄັດກອງຕົ້ນທາງ -->
    <div class="panel filter-panel">
      <div class="panel-head">
        <h3><i class="fas fa-search"></i> 1. ເລືອກກຸ່ມນັກຮຽນຕົ້ນທາງ</h3>
      </div>
      <div class="panel-body">
        <div class="field-row-3">
          <div class="form-group">
            <label>ຊັ້ນຮຽນປັດຈຸບັນ</label>
            <select v-model="filters.grade" @change="fetchStudents">
              <option value="">-- ເລືອກຊັ້ນຮຽນ --</option>
              <option v-for="item in classList" :key="item.value" :value="item.value">{{ item.text }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>ສົກຮຽນປັດຈຸບັນ</label>
            <select v-model="filters.academicYear" @change="fetchStudents">
              <option v-for="item in accdList" :key="item.value" :value="item.text">{{ item.text }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>ຫ້ອງຮຽນ</label>
            <select v-model="filters.room_no" @change="fetchStudents">
              <option value="">ທັງໝົດ</option>
              <option v-for="n in 20" :key="n" :value="n">ຫ້ອງ {{ n }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <!-- ຕາຕະລາງລາຍຊື່ -->
    <div class="panel mt-4 table-panel" v-if="students.length > 0">
      <div class="panel-head">
        <h3><i class="fas fa-users"></i> ລາຍຊື່ນັກຮຽນ (ເລືອກຜູ້ທີ່ເສັງຜ່ານ)</h3>
        <div class="selection-info">ເລືອກແລ້ວ: <strong>{{ selectedIds.length }}</strong> ຄົນ</div>
        <button class="btn-export" @click="exportToExcel" :disabled="students.length === 0">
          <i class="fas fa-file-excel"></i> ສົ່ງອອກ Excel
        </button>
      </div>
      <div class="panel-body">
        <div class="table-wrap mt-2">
          <table class="promotion-table">
            <thead>
              <tr>
                <th width="50"><input type="checkbox" @change="toggleSelectAll" :checked="isAllSelected"></th>
                <th>ລຳດັບ</th>
                <th>ລະຫັດ</th>
                <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                <th>ເພດ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(s, index) in students" :key="s._id" :class="{ 'selected-row': selectedIds.includes(s._id) }">
                <td><input type="checkbox" v-model="selectedIds" :value="s._id"></td>
                <td>{{ index + 1 }}</td>
                <td><span class="asset-code">{{ s.student_id }}</span></td>
                <td>{{ s.firstNameLao }} {{ s.familyNameLao }}</td>
                <td>{{ s.gender === 'ຊ' ? 'ຊາຍ' : 'ຍິງ' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ສ່ວນກຳນົດປາຍທາງ -->
    <div class="panel mt-4 table-panel" v-if="selectedIds.length > 0">
      <div class="panel-head bg-light-blue">
        <h3><i class="fas fa-arrow-circle-up"></i> 2. ກຳນົດຊັ້ນຮຽນ/ສົກຮຽນ ທີ່ຈະເລືອນຂຶ້ນ</h3>
      </div>
      <div class="panel-body">
        <div class="field-row-3">
          <div class="form-group" :class="{ 'has-error': validationErrors.targetGrade }">
            <label>ເລືອນຂຶ້ນຊັ້ນຮຽນ</label>
            <select v-model="promotionSettings.targetGrade" @change="clearValidationError('targetGrade')">
              <option value="">-- ເລືອກຊັ້ນຮຽນ --</option>
              <option v-for="item in classList" :key="item.value" :value="item.value">{{ item.text }}</option>
            </select>
            <div class="error-text" v-if="validationErrors.targetGrade">{{ validationErrors.targetGrade }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validationErrors.targetYear }">
            <label>ສົກຮຽນໃໝ່</label>
            <select v-model="promotionSettings.targetYear" @change="clearValidationError('targetYear')">
              <option value="">-- ເລືອກສົກຮຽນ --</option>
              <option v-for="item in accdList" :key="item.value" :value="item.text">{{ item.text }}</option>
            </select>
            <div class="error-text" v-if="validationErrors.targetYear">{{ validationErrors.targetYear }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validationErrors.targetRoom }">
            <label>ຫ້ອງຮຽນໃໝ່</label>
            <select v-model="promotionSettings.targetRoom" @change="clearValidationError('targetRoom')">
              <option value="">-- ເລືອກຫ້ອງ --</option>
              <option v-for="n in 20" :key="n" :value="n">ຫ້ອງ {{ n }}</option>
            </select>
            <div class="error-text" v-if="validationErrors.targetRoom">{{ validationErrors.targetRoom }}</div>
          </div>
        </div>
        <div class="form-actions-wrapper mt-4 border-top pt-4">
          <div class="action-right">
            <button class="btn-save btn-block" @click="showConfirm" :disabled="submitting">
              <i class="fas" :class="submitting ? 'fa-spinner fa-spin' : 'fa-graduation-cap'"></i> 
              {{ submitting ? 'ກຳລັງດຳເນີນການ...' : 'ຢືນຢັນການເລືອນຊັ້ນນັກຮຽນ' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading Overlay ສໍາລັບການປະມວນຜົນການເລືອນຊັ້ນ -->
    <div v-if="submitting" class="loading-overlay">
      <div class="loader-content">
        <i class="fas fa-spinner fa-spin fa-3x"></i>
        <p>ກຳລັງປະມວນຜົນການເລືອນຊັ້ນ...</p>
        <div class="progress-container">
          <div class="progress-bar" :style="{ width: promotionProgress + '%' }"></div>
        </div>
        <div class="progress-text">{{ promotionProgress }}%</div>
        <span>ກະລຸນາລໍຖ້າຈົນກວ່າຂະບວນການຈະສຳເລັດ</span>
      </div>
    </div>

    <!-- Modal ຢືນຢັນ (Confirm Modal) -->
    <transition name="modal">
      <div v-if="confirmModal.show" class="modal-overlay" @mousedown.self="confirmModal.show = false">
        <div class="custom-modal-card result-modal">
          <div class="modal-icon warning">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="modal-content-area">
            <h2>ຢືນຢັນການເລືອນຊັ້ນ</h2>
            <p>ທ່ານຕ້ອງການເລືອນຊັ້ນນັກຮຽນທັງໝົດ <strong>{{ selectedIds.length }}</strong> ຄົນ ນີ້ແມ່ນບໍ່?</p>
          </div>
          <div class="modal-footer-actions">
            <button class="btn-modal-secondary" @click="confirmModal.show = false">ຍົກເລີກ</button>
            <button class="btn-modal-primary" @click="handlePromotion">ຕົກລົງ, ດຳເນີນການ</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal ແຈ້ງຜົນຮັບ (Result Modal) -->
    <transition name="modal">
      <div v-if="resultModal.show" class="modal-overlay" @mousedown.self="resultModal.show = false">
        <div class="custom-modal-card result-modal">
          <div class="modal-icon" :class="resultModal.type">
            <i class="fas" :class="resultModal.type === 'success' ? 'fa-check-circle' : 'fa-times-circle'"></i>
          </div>
          <div class="modal-content-area">
            <h2>{{ resultModal.title }}</h2>
            <p>{{ resultModal.message }}</p>
          </div>
          <div class="modal-footer-actions">
            <button 
              class="btn-modal-primary" 
              :class="resultModal.type" 
              @click="resultModal.show = false"
            >
              ເຂົ້າໃຈແລ້ວ
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/utils/api';
import * as XLSX from 'xlsx';

export default {
  name: 'PromotionPage',
  data() {
    return {
      loading: false,
      submitting: false,
      filters: { grade: '', academicYear: '2024-2025', room_no: '' },
      promotionSettings: { targetGrade: '', targetYear: '2025-2026', targetRoom: '' },
      students: [],
      promotionProgress: 0,
      confirmModal: { show: false },
      resultModal: { show: false, type: 'success', title: '', message: '' },
      selectedIds: [],
      classList: [],
      accdList: [],
      schoolName: '',
      provinceName: '',
      districtName: '',
      validationErrors: {},
      user: JSON.parse(localStorage.getItem("user-info") || "{}")
    }
  },
  computed: {
    isAllSelected() {
      return this.students.length > 0 && this.selectedIds.length === this.students.length;
    }
  },
  mounted() {
    this.fetchClassList();
    this.fetchAccdList();
    this.fetchSchoolLocation();
  },
  methods: {
    async fetchClassList() {
      const res = await api.get('/getItems/class_list/class_desc_lao/id');
      this.classList = res.data;
    },
    async fetchAccdList() {
      const res = await api.get('/getItems/accd/accd/id');
      this.accdList = res.data.sort((a, b) => b.text.localeCompare(a.text));
    },
    async fetchSchoolLocation() {
      try {
        if (this.user.school_id) {
          const school = await api.get(`/getAll/schools/school_id/${this.user.school_id}`);
          if (school.data.code === 1 && school.data.rows.length > 0) this.schoolName = school.data.rows[0].school_name_lao;
        }
        if (this.user.prov_id) {
          const prov = await api.get(`/getItems/province/prov_name/prov_id?id=${this.user.prov_id}`);
          if (prov.data && prov.data.length > 0) this.provinceName = prov.data[0].text;
        }
        if (this.user.district_id) {
          const dist = await api.get(`/getItemsCondition/district/district_name_lao/district_id/prov_id/${this.user.prov_id}?id=${this.user.district_id}`);
          if (dist.data && dist.data.length > 0) this.districtName = dist.data[0].text;
        }
      } catch (error) {
        console.error('Fetch school location error:', error);
      }
    },
    getNextGrade(currentValue) {
      const idx = this.classList.findIndex(c => c.value == currentValue);
      if (idx === -1 || idx === this.classList.length - 1) return currentValue;
      return this.classList[idx + 1].value;
    },
    getNextAcademicYear(accd) {
      const match = String(accd || '').match(/^(\d{4})-(\d{4})$/);
      if (!match) return accd;
      const start = parseInt(match[1], 10) + 1;
      const end = parseInt(match[2], 10) + 1;
      return `${start}-${end}`;
    },
    async fetchStudents() {
      if (!this.filters.grade) return;
      this.loading = true;
      this.selectedIds = [];
      this.promotionSettings.targetGrade = this.getNextGrade(this.filters.grade);
      this.promotionSettings.targetYear = this.getNextAcademicYear(this.filters.academicYear);
      try {
        const res = await api.get('/students/classlist' , {
          params: { 
            Grade_Code: this.filters.grade, 
            accd: this.filters.academicYear,
            school_id: this.user.school_id,
            room_no:  this.filters.room_no
          }
        });
        if (res.data.code === 1) {
          this.students = res.data.rows;
        }
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedIds = [];
      } else {
        this.selectedIds = this.students.map(s => s._id);
      }
    },
    exportToExcel() {
      if (this.students.length === 0) {
        alert('ບໍ່ມີຂໍ້ມູນທີ່ຈະສົ່ງອອກ.');
        return;
      }

      try {
        const gradeObj = this.classList.find(c => c.value == this.filters.grade);
        const gradeName = gradeObj ? gradeObj.text : this.filters.grade;

        const header = ['ລຳດັບ', 'ລະຫັດໂຮງຮຽນ', 'ຊື່ໂຮງຮຽນ', 'ແຂວງ', 'ເມືອງ', 'ຊັ້ນຮຽນ', 'ສົກຮຽນ', 'ລະຫັດນັກຮຽນ', 'ຊື່ ແລະ ນາມສະກຸນ', 'ເພດ'];
        const data = this.students.map((s, index) => [
          index + 1,
          this.user.school_id,
          this.schoolName,
          this.provinceName,
          this.districtName,
          gradeName,
          this.filters.academicYear,
          s.student_id,
          `${s.firstNameLao} ${s.familyNameLao}`,
          s.gender === 'ຊ' ? 'ຊາຍ' : 'ຍິງ',
        ]);

        const ws = XLSX.utils.aoa_to_sheet([header, ...data]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'ລາຍຊື່ນັກຮຽນ');

        const ts = new Date().toISOString().slice(0, 10);
        const filename = `ລາຍຊື່ນັກຮຽນ_${gradeName}_${this.filters.academicYear}_${ts}.xlsx`;
        XLSX.writeFile(wb, filename);
      } catch (error) {
        console.error('Excel Export Error:', error);
        alert('ເກີດຂໍ້ຜິດພາດໃນການສົ່ງອອກໄຟລ໌ Excel');
      }
    },
    clearValidationError(field) {
      if (this.validationErrors[field]) {
        this.$set(this.validationErrors, field, null);
      }
    },
    showConfirm() {
      if (this.selectedIds.length === 0) {
        this.showResult('warning', 'ແຈ້ງເຕືອນ', 'ກະລຸນາເລືອກນັກຮຽນຢ່າງໜ້ອຍ 1 ຄົນ');
        return;
      }

      const newErrors = {};
      if (!this.promotionSettings.targetGrade) newErrors.targetGrade = 'ກະລຸນາເລືອກຊັ້ນຮຽນໃໝ່';
      if (!this.promotionSettings.targetYear) newErrors.targetYear = 'ກະລຸນາເລືອກສົກຮຽນໃໝ່';
      if (!this.promotionSettings.targetRoom) newErrors.targetRoom = 'ກະລຸນາເລືອກຫ້ອງຮຽນໃໝ່';
      this.validationErrors = newErrors;

      if (Object.keys(newErrors).length > 0) {
        this.showResult('warning', 'ແຈ້ງເຕືອນ', 'ກະລຸນາເລືອກຊັ້ນຮຽນ, ສົກຮຽນ ແລະ ຫ້ອງຮຽນໃໝ່ໃຫ້ຄົບຖ້ວນ');
        return;
      }

      this.confirmModal.show = true;
    },
    showResult(type, title, message) {
      this.resultModal = { show: true, type, title, message };
    },
    async handlePromotion() {
      this.confirmModal.show = false;
      this.submitting = true;
      this.promotionProgress = 0;

      // ຊອກຫາຊື່ຊັ້ນຮຽນ (Label) ຂອງຕົ້ນທາງ ແລະ ປາຍທາງ ເພື່ອສົ່ງໄປບັນທຶກນຳ
      const fromGradeObj = this.classList.find(c => c.value == this.filters.grade);
      const toGradeObj = this.classList.find(c => c.value == this.promotionSettings.targetGrade);

      const total = this.selectedIds.length;
      const batchSize = 5; // ປະມວນຜົນເທື່ອລະ 5 ລາຍການເພື່ອໃຫ້ເຫັນ Progress ເຄື່ອນໄຫວໄດ້ນຸ້ມນວນ

      try {
        for (let i = 0; i < total; i += batchSize) {
          const chunk = this.selectedIds.slice(i, i + batchSize);
          const res = await api.post('/students/promote', {
            studentIds: chunk,
            ...this.promotionSettings,
            fromGradeName: fromGradeObj ? fromGradeObj.text : '',
            toGradeName: toGradeObj ? toGradeObj.text : '',
            fromGrade: this.filters.grade,
            fromAcademicYear: this.filters.academicYear,
            fromRoomNo: this.filters.room_no,
             
          });
          
          if (res.data.code !== 1) {
            throw new Error(res.data.msg || 'ເກີດຂໍ້ຜິດພາດໃນບາງລາຍການ');
          }
          
          // ຄິດໄລ່ເປີເຊັນຄວາມຄືບໜ້າ
          const processed = Math.min(i + batchSize, total);
          this.promotionProgress = Math.round((processed / total) * 100);
        }
        
        this.showResult('success', 'ສຳເລັດແລ້ວ', 'ການເລືອນຊັ້ນນັກຮຽນທັງໝົດຖືກດຳເນີນການຮຽບຮ້ອຍແລ້ວ');
        this.fetchStudents();
      } catch (e) {
        const errorMsg = e.response && e.response.data ? e.response.data.msg : (e.message || 'ເກີດຂໍ້ຜິດພາດໃນການເລືອນຊັ້ນ');
        this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', errorMsg);
      } finally {
        this.submitting = false;
        setTimeout(() => { this.promotionProgress = 0; }, 500);
      }
    }
  }
}
</script>

<style >
.promotion-container { animation: fadeIn 0.4s ease-out; max-width: 1200px; margin: 0 auto; }

.filter-panel { border-top: 4px solid var(--lao); margin-bottom: 24px; }
.table-panel { border-radius: 12px; overflow: hidden; box-shadow: 0 10px 15px -3px rgba(0,0,0,0.05); }

.bg-light-blue { background-color: #f0f7ff !important; border-bottom: 2px solid var(--lao) !important; }
.selection-info { font-size: 14px; color: var(--lao); font-weight: 600; }

.table-wrap { max-height: 50vh; overflow-y: auto; border: 1px solid var(--border); border-radius: 8px; }
.promotion-table { width: 100%; border-collapse: separate; border-spacing: 0; background: white; }

.promotion-table th { 
  position: sticky; top: 0; background: #f8fafc; z-index: 10; padding: 15px 12px;
  border-bottom: 2px solid var(--border); text-align: left; font-size: 13px; color: var(--text1); font-weight: 700;
}

.promotion-table td { padding: 12px; border-bottom: 1px solid #edf2f7; font-size: 14px; transition: background 0.2s; }
.promotion-table tr:hover td { background-color: #f8fafc; }
.selected-row td { background-color: #fffbeb !important; }

.form-group label { display: block; font-size: 13px; color: var(--text2); margin-bottom: 8px; font-weight: 600; }
.form-group select, .form-group input { width: 100%; padding: 10px; border: 1px solid var(--border); border-radius: 8px; font-size: 14px; transition: all 0.2s; }
.form-group select:focus { border-color: var(--lao); box-shadow: 0 0 0 3px var(--lao-light); }

.form-group.has-error select {
  border-color: var(--danger);
  background-color: #fffafa;
}
.error-text {
  color: var(--danger);
  font-size: 12px;
  margin-top: 5px;
}

.field-row-3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 20px; }

.form-actions-wrapper { display: flex; justify-content: flex-end; align-items: center; }
.btn-block { min-width: 300px; justify-content: center; font-size: 15px; padding: 12px 30px; }

.btn-save { 
  background: var(--lao); color: white; border: none; border-radius: 8px; cursor: pointer; 
  font-weight: 600; display: flex; align-items: center; gap: 8px; transition: 0.3s; 
}
.btn-save:hover:not(:disabled) { background: #002d62; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,63,138,0.3); }
.btn-save:disabled { opacity: 0.6; cursor: not-allowed; }

.btn-export {
  background: #10b981; color: white; border: none; border-radius: 8px; cursor: pointer;
  font-weight: 600; padding: 8px 16px; font-size: 13px; display: flex; align-items: center; gap: 8px; transition: 0.2s;
}
.btn-export:hover:not(:disabled) { background: #059669; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3); }
.btn-export:disabled { opacity: 0.6; cursor: not-allowed; }

.asset-code { background: #e2e8f0; padding: 2px 8px; border-radius: 4px; font-family: 'IBM Plex Mono', monospace; font-size: 12px; font-weight: 600; color: #475569; }

.border-top { border-top: 1px solid var(--border); }
.pt-4 { padding-top: 1.5rem; }

/* Scrollbar Styling */
.table-wrap::-webkit-scrollbar { width: 8px; height: 8px; }
.table-wrap::-webkit-scrollbar-track { background: #f1f5f9; }
.table-wrap::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

@media (max-width: 768px) {
  .field-row-3 { grid-template-columns: 1fr; gap: 15px; }
  .btn-block { width: 100%; }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Loading Overlay Styling */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

.loader-content {
  text-align: center;
  color: var(--lao);
}

.loader-content i { margin-bottom: 20px; }
.loader-content p { font-size: 1.25rem; font-weight: 700; margin: 0 0 10px 0; }
.loader-content span { color: #64748b; font-size: 0.9rem; }

.progress-container { width: 300px; height: 12px; background: #e2e8f0; border-radius: 10px; margin: 20px auto 10px; overflow: hidden; }
.progress-bar { 
  height: 100%; 
  background: linear-gradient(90deg, var(--lao) 0%, #3b82f6 100%); 
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1); 
}
.progress-text { font-weight: 800; color: var(--lao); font-size: 1.1rem; margin-bottom: 15px; }

/* Modal Overlay Styling - ເພີ່ມເພື່ອໃຫ້ Modal ຢູ່ເຄິ່ງກາງໜ້າຈໍ */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
}

/* Result & Confirm Modal Custom Styling */
.result-modal { 
  padding: 40px 30px; 
  max-width: 400px !important; 
  text-align: center; 
  background: white; 
  border-radius: 16px; 
  box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1); 
}
.modal-icon { font-size: 64px; margin-bottom: 20px; }
.modal-icon.success { color: #10b981; }
.modal-icon.error { color: #ef4444; }
.modal-icon.warning { color: #f59e0b; }

.modal-content-area h2 { margin: 0 0 10px; font-size: 1.6rem; color: #0f172a; font-weight: 800; }
.modal-content-area p { color: #334155; font-size: 1.05rem; line-height: 1.6; margin-bottom: 30px; font-weight: 500; }

.modal-footer-actions { display: flex; gap: 12px; justify-content: center; }

.btn-modal-primary {
  padding: 12px 24px; border: none; border-radius: 10px; cursor: pointer;
  font-weight: 600; font-size: 14px; background: var(--lao); color: white;
  transition: 0.2s; min-width: 140px;
}
.btn-modal-primary:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0, 63, 138, 0.2); }
.btn-modal-primary.success { background: #10b981; }
.btn-modal-primary.success:hover { background: #059669; }
.btn-modal-primary.error { background: #ef4444; }
.btn-modal-primary.error:hover { background: #dc2626; }

.btn-modal-secondary {
  padding: 12px 24px; border: 1.5px solid #e2e8f0; border-radius: 10px;
  cursor: pointer; font-weight: 600; font-size: 14px; background: white;
  color: #475569; transition: 0.2s; min-width: 120px;
}
.btn-modal-secondary:hover { background: #f8fafc; color: var(--text1); }

/* Modal Animation */
.modal-enter-active, .modal-leave-active { transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
.modal-enter, .modal-leave-to { opacity: 0; }
.modal-enter-active .custom-modal-card { animation: modalIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1); }
.modal-leave-active .custom-modal-card { animation: modalOut 0.2s ease-in; }

@keyframes modalIn {
  from { opacity: 0; transform: scale(0.8) translateY(20px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

@keyframes modalOut {
  from { opacity: 1; transform: scale(1); }
  to { opacity: 0; transform: scale(0.9); }
}

</style>